import type { ReactNode } from "react";
import { Button } from "react-aria-components";

type Props = {
  text: string;
  onClick: any;
  leftIcon: ReactNode;
};

export function FloatingButton({ text, onClick, leftIcon }: Props) {
  return (
    <Button
      className="absolute bottom-13.5 left-1/2 mb-4 flex h-8 min-h-8 w-fit min-w-22.5 -translate-x-1/2 items-center justify-center gap-2 rounded-2xl bg-icon-primary px-4 py-2 text-text-on-bg-fill shadow-sm focus:ring-1 active:bg-icon-primary-active"
      onPress={onClick}
      id="hex-map-button"
    >
      {leftIcon}
      <span>{text}</span>
    </Button>
  );
}
